// Token-LESS public API client.
//
// AxiosWrapper's `useApi` always attaches an Auth0 bearer token (it calls
// `getAccessTokenSilently`), so it can't be used from unauthenticated marketing
// surfaces like the public `/demo` route. This helper performs a plain POST
// against the same resolved base URL (see apiBaseUrl.ts) with NO Authorization
// header and no dependency on `useAuth0` / the authed app shell.
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiBaseUrl } from './apiBaseUrl';

const publicApi = {
  post: async <T = unknown>(
    path: string,
    body?: unknown,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> => {
    const url = `${getApiBaseUrl()}${path}`;
    return axios.post<T>(url, body, config);
  },
};

export default publicApi;
